import { render, staticRenderFns } from "./document-list-group-input.vue?vue&type=template&id=7b21601a&scoped=true&"
import script from "./document-list-group-input.ts?vue&type=script&lang=ts&"
export * from "./document-list-group-input.ts?vue&type=script&lang=ts&"
import style0 from "./document-list-group-input.scss?vue&type=style&index=0&id=7b21601a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b21601a",
  null
  
)

export default component.exports